import React, { Fragment, memo } from 'react';
import ReactLightBox from 'yet-another-react-lightbox';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';

import LightboxImageProps from './props';

import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';

/**
 * ===========================
 * MAIN
 * ===========================
 */
const LightboxImageView: React.FC<LightboxImageProps> = (props) => {
  const { open, source, imageFit = 'contain', imageProps, onClose } = props;
  const { style: imageStyle, ...restImagePros } = imageProps || {};
  // ========================= HOOKS
  // ========================= EVENTS
  // ========================= VARIABLES
  // ========================= EFFECTS
  // ========================= VIEWS
  return (
    <Fragment>
      <ReactLightBox
        plugins={[Zoom]}
        controller={{
          closeOnBackdropClick: true,
          closeOnPullDown: true,
          closeOnPullUp: false,
        }}
        animation={{
          fade: 500,
        }}
        carousel={{
          finite: true,
          imageFit,
          imageProps: {
            style: {
              aspectRatio: 1,
              ...imageStyle,
            },
            ...restImagePros,
          },
        }}
        render={{
          iconPrev: () => null,
          iconNext: () => null,
        }}
        zoom={{
          maxZoomPixelRatio: 10,
          zoomInMultiplier: 1.5,
          doubleTapDelay: 300,
          doubleClickDelay: 500,
          doubleClickMaxStops: 100,
          keyboardMoveDistance: 10,
          wheelZoomDistanceFactor: 100,
          pinchZoomDistanceFactor: 100,
          scrollToZoom: true,
        }}
        styles={{
          root: {
            '--yarl__color_backdrop': 'rgba(0, 0, 0, 1)',
            '--yarl__button_filter': 'none',
            '--yarl__counter_filter': 'none',
            '--yarl__color_button': 'hsla(0,0%,100%,1)',
            '--yarl__color_button_disabled': 'hsla(0,0%,100%,.5)',
          },
        }}
        slides={[source]}
        open={open}
        close={onClose}
      />
    </Fragment>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export * from './props';
export const LightboxImage = memo(LightboxImageView);
export default LightboxImage;
